import '.';
import { Query } from '../Model/Query';
import { SubtypesDiligences } from '../Model/SubtypesDiligences';
export class SubtypesDiligencesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findSubtypes(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`subtypes?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los subtipos.`);
            }
            const content = await response.json();
            return content.map(diligence => new SubtypesDiligences(diligence).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findOne(subtypeId) {
        if (subtypeId) {
            const response = await this.apiService.get('subtypes/' + subtypeId);
            if (!response.ok) {
                throw new Error(`Error al obtener el subtipo de la diligencia.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener subtipo de la diligencia.`);
        }
    }
    async find() {
        const response = await this.apiService.get('subtypes');
        if (!response.ok) {
            throw new Error(`Error al obtener las subtypes.`);
        }
        const content = await response.json();
        return content.map(crime => new SubtypesDiligences(crime).getState());
    }
    async findByDiligence(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('subtypes/query/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener el subtipo de la diligencia.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener subtipo de la diligencia.`);
        }
    }
    async removeSubType(subtype) {
        if (subtype) {
            const response = await this.apiService.post('subtype/remove', subtype instanceof SubtypesDiligences ? subtype.getState() : subtype);
            if (!response.ok) {
                throw new Error(`Error al eliminar el parametro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener param.`);
        }
    }
    async saveSubType(subtype) {
        if (subtype) {
            const response = await this.apiService.post('subtype', subtype instanceof SubtypesDiligences ? subtype.getState() : subtype);
            if (!response.ok) {
                throw new Error(`Error al guardar el parametro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener param.`);
        }
    }
}
